import React, { useState } from "react";
import emailjs from "emailjs-com";
import "./PopupForm.css"; // Add styles for the modal

const PopupForm = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  // Handle form submission
const handleSubmit = (e) => {
  e.preventDefault();

  const templateParams = {
    email: formData.email,
    message: formData.message,
  };

  emailjs
    .send("service_hfjuhy8", "template_cv0fu57", templateParams, "AKDzfoXfa9922wbXV")
    .then(
      (result) => {
        console.log(result.text);
        setStatus("Message sent successfully!");
        setFormData({ email: "", message: "" });
      },
      (error) => {
        console.log(error.text);
        setStatus("Failed to send message. Please try again.");
      }
    );
};

  return isOpen ? (
    <div className="popup-overlay">
      <div className="popup-container">
        <button className="close-button" onClick={onClose}>✖</button>
        <h3 className="popup-heading">Get in Touch</h3>
        {status && <p className="status-message">{status}</p>}
        <form onSubmit={handleSubmit}>
          <label className="popup-label">Your Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />

          <label className="popup-label">Message</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            required
          ></textarea>

          <button type="submit">Send Message</button>
        </form>
      </div>
    </div>
  ) : null;
};

export default PopupForm;
